import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './de.json';
import en from './en.json';

const KEY = 'dq.lang';
let lng = 'de';
try {
  const v = localStorage.getItem(KEY);
  if (v === 'en' || v === 'de') lng = v;
} catch {
  /* ohne Speicher */
}

void i18n.use(initReactI18next).init({
  resources: { de: { translation: de }, en: { translation: en } },
  lng,
  fallbackLng: 'de',
  interpolation: { escapeValue: false },
  returnNull: false,
});
if (typeof document !== 'undefined') document.documentElement.lang = lng;

export function setLanguage(l: 'de' | 'en') {
  void i18n.changeLanguage(l);
  document.documentElement.lang = l;
  try {
    localStorage.setItem(KEY, l);
  } catch {
    /* ohne Speicher */
  }
}

export const localeOf = (l: string) => (l === 'en' ? 'en-GB' : 'de-CH');
export default i18n;
